// LOGIN
export const API_LOGIN_REQUEST = 'API_LOGIN_REQUEST';
export const API_LOGIN_REQUEST_SUCCESS = 'API_LOGIN_REQUEST_SUCCESS';
export const API_LOGIN_REQUEST_FAILED = 'API_LOGIN_REQUEST_FAILED';
export const LOGIN_CALLBACK = 'LOGIN_CALLBACK';

// SIGNUP
export const API_SIGNUP_REQUEST = 'API_SIGNUP_REQUEST';
export const API_SIGNUP_SUCCESS = 'API_SIGNUP_SUCCESS';
export const API_SIGNUP_FAILED = 'API_SIGNUP_FAILED';


// REFRESH_TOKEN
export const REFRESH_TOKEN_REQUEST = 'REFRESH_TOKEN_REQUEST';
export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS';
export const REFRESH_TOKEN_FAILED = 'REFRESH_TOKEN_FAILED';


// LOGOUT
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const CLEAR_TOKEN = 'CLEAR_TOKEN';
export const RESET_MSG = 'RESET_MSG';

// user information
export const SET_USER_INFORMATION = 'SET_USER_INFORMATION';

// REQUEST PASSWORD RESET
export const API_PASSWORD_RESET_REQUEST = 'API_PASSWORD_RESET_REQUEST';
export const API_PASSWORD_RESET_SUCCESS = 'API_PASSWORD_RESET_SUCCESS';
export const API_PASSWORD_RESET_FAILED = 'API_PASSWORD_RESET_FAILED';

// GET_PROFILE
export const GET_PROFILE_REQUEST = "GET_PROFILE_REQUEST";
export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS";
export const GET_PROFILE_FAILED = "GET_PROFILE_FAILED";

// EDIT_PROFILE
export const EDIT_PROFILE_REQUEST = "EDIT_PROFILE_REQUEST";
export const EDIT_PROFILE_SUCCESS = "EDIT_PROFILE_SUCCESS";
export const EDIT_PROFILE_FAILED = "EDIT_PROFILE_FAILED";


// SET_OPEN_CHAT
export const SET_OPEN_CHAT = "SET_OPEN_CHAT";

// REQUEST PASSWORD RESET CONFIRM
export const API_PASSWORD_RESET_CONFIRM_REQUEST =
  'API_PASSWORD_RESET_CONFIRM_REQUEST';
export const API_PASSWORD_RESET_CONFIRM_SUCCESS =
  'API_PASSWORD_RESET_CONFIRM_SUCCESS';
export const API_PASSWORD_RESET_CONFIRM_FAILED =
  'API_PASSWORD_RESET_CONFIRM_FAILED';

// HANDLE_SIDE_BAR_NAVIGATION
export const HANDLE_SIDE_BAR_NAVIGATION = 'HANDLE_SIDE_BAR_NAVIGATION';

// HANDLE_SELECT_USER
export const HANDLE_SELECT_USER = 'HANDLE_SELECT_USER';

